import React, { ReactNode } from 'react'
import { StepContent as MUIStepContent, SxProps } from '@mui/material'

// Only valid inside a Stepper with orientation="vertical".
interface StepContentProps {
  children?: ReactNode
  sx?: SxProps
}

const StepContent = React.forwardRef((props: StepContentProps, ref: any) => {
  return (
    <MUIStepContent {...props} ref={ref}>
      {props.children}
    </MUIStepContent>
  )
})

StepContent.displayName = 'StepContent'
export default StepContent
